import { NavigationService } from './shared/services/navigation.service';
import { Component, OnInit, ViewChild, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { BreakpointObserver } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';

import { LoaderComponent } from './core/loader/loader.component';
import { BehaviorSubject } from 'rxjs';
import { LanguageService } from './core/i18n/language.service';
import { ThemeService } from './shared/services/theme.service';
import { AuthService } from './shared/services/auth.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [CommonModule, RouterOutlet, LoaderComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
    title = 'Ratoeira Ads - A melhor ferramenta de trackeamento do mercado';

    @ViewChild(MatSidenav)
    sidenav!: MatSidenav;
    isMobile = true;
    isCollapsed = true;

    static isBrowser: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);

    constructor(
        @Inject(PLATFORM_ID) private platformId: object,
        private observer: BreakpointObserver,
        private navigationService: NavigationService,
        public router: Router,
        private languageService: LanguageService,
        private themeService: ThemeService,
        _authService: AuthService,
    ) {
        AppComponent.isBrowser.next(isPlatformBrowser(platformId));
        this.languageService.init();
    }

    ngOnInit() {
        this.observer.observe(['(max-width: 800px)']).subscribe((screenSize) => {
            if (screenSize.matches) {
                this.isMobile = true;
            } else {
                this.isMobile = false;
            }
        });
    }

    toggleMenu() {
        if (this.isMobile) {
            this.sidenav.toggle();
            this.isCollapsed = false; // On mobile, the menu can never be collapsed
        } else {
            this.sidenav.open(); // On desktop/tablet, the menu can never be fully closed
            this.isCollapsed = !this.isCollapsed;
        }
    }

    public goTo(url: string) {
        this.navigationService.goTo(url);
    }
}
